import { TaskStatusFilter } from 'constants/index'

// ---- Payload ----
export interface CreateTaskPayload {
  sourceBinCode: string
  destinationBinCode: string
  productCode: string
  quantity?: number
}

export interface TaskFetchParams {
  warehouseID: string
  status?: string
  keyword?: string
  page?: number
  pageSize?: number
}

// ---- Response ----
export type UITask = any & {
  destinationBinCode?: string
  sourceBins?: Array<{
    bin?: { binCode?: string }
    quantity?: number
    inventoryID?: string
  }>
}

export type TaskUpdatePayload = {
  sourceBinCode?: string
  status?: string
  note?: string | null
}

export type TaskCancelParams = {
  warehouseID: string
  status: TaskStatusFilter
  keyword: string
}

/** 与 worker / picker 约定：`PATCH /tasks/:id` 的 `note` 加急取值 */
export const isRushTaskNote = (note?: string | null) =>
  note === 'RUSH_TASK' || note === 'URGENT' || note === '加急'
